import entity from '../../../models/loads/carriers'

export default [
  {
    path: '/carriers',
    meta: {
      entity,
      requiresPermissionTo: 'carriers',
      crud: 'list'
    },
    component: () =>
      import(
        /* webpackChunkName: 'banners' */ '@/views/dynamic/DynamicIndex.vue'
      )
  },
  {
    path: '/carriers/new',
    meta: {
      entity,
      requiresPermissionTo: 'carriers',
      crud: 'form'
    },
    component: () =>
      import(
        /* webpackChunkName: 'banners' */ '@/views/dynamic/DynamicIndex.vue'
      )
  },
  {
    path: '/carriers/:id',
    meta: {
      entity,
      requiresPermissionTo: 'carriers',
      crud: 'form'
    },
    component: () =>
      import(
        /* webpackChunkName: 'banners' */ '@/views/dynamic/DynamicIndex.vue'
      )
  }
]
